// extracted by mini-css-extract-plugin
export default {"MsNotify":"style_MsNotify__iSRmV","Name":"style_Name__6x5lL","MsEquipments":"style_MsEquipments__wv2d5"};